// extracted by mini-css-extract-plugin
export var actionButton = "_6d-1";
export var actionButtons = "_6d-2";
export var actions = "_6d-0";
export var aiUnread = "_6d-10";
export var alignCenter = "_6d-h";
export var backWrapper = "_6d-3";
export var cellContainer = "_6d-4";
export var checkboxContainer = "_6d-5";
export var contentContainer = "_6d-6";
export var contentHeader = "_6d-8";
export var conversationsTableWrapper = "_6d-s";
export var draftReplyBadgeContainer = "_6d-m";
export var dropdownItem = "_6d-b";
export var dropdownItemsContainer = "_6d-a";
export var dropdownTitle = "_6d-c";
export var errorIcon = "_6d-7";
export var filter = "_6d-d";
export var gray = "_6d-i";
export var headerActionButtons = "_6d-e";
export var headerCheckboxContainer = "_6d-f";
export var icon = "_6d-j";
export var menuContainer = "_6d-k";
export var noMoreTicketsIcon = "_6d-12";
export var noMoreTicketsSubText = "_6d-13";
export var oneLine = "_6d-l";
export var optionsButton = "_6d-n";
export var plus = "_6d-o";
export var portalButtonsWrapper = "_6d-g";
export var red = "_6d-p";
export var scrolledTop = "_6d-9";
export var search = "_6d-q";
export var selectedConversationsCount = "_6d-r";
export var spinner = "_6d-t";
export var strong = "_6d-u";
export var summaryCell = "_6d-v";
export var tableContainer = "_6d-11";
export var tagContainer = "_6d-w";
export var threeDots = "_6d-x";
export var twoLines = "_6d-y";
export var unread = "_6d-z";